import React from 'react';
import PropTypes from 'prop-types'

import modalFoundation from '../../hoc/modalFoundation.js';

import './postRequestAlertModal.scss';

/**
 * Defines the id of the modal.
 * @type {string}
 */
const MODAL_ID = 'post-request-alert-modal';

/**
 * Modal Options.
 *
 * @type {{closeOnClick: boolean}}
 */
const modalOptions = {
  closeOnClick: false,
};

/**
 * The postRequest you popup modal.
 */
export class PostRequestAlertModal extends React.Component {
  /**
   * @constructor
   * @param {{}} props
   * @param {{}} componentContext
   */
  constructor(props, componentContext) {
    super(props, componentContext);
  }

  /**
   * Closes the modal.
   */
  closeModal = () => {
    location.reload();
    this.props.modalFoundation.hide();
  };

  /**
   * Renders the modal.
   *
   * @returns {object}
   */
  render() {
    return (
      <div id={MODAL_ID} className="reveal wgl-modal" tabIndex="-1" role="dialog">
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h1>We have received your request and will contact you with any questions.</h1>
            </div>
            <div className="modal-footer">
              <button type="button" className="button" onClick={this.closeModal}>Ok</button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

PostRequestAlertModal.propTypes = {
  // ModalFoundation HOC
  modalFoundation: PropTypes.shape({
    hide: PropTypes.func.isRequired,
  }),
};

export default modalFoundation(MODAL_ID, modalOptions)(
  PostRequestAlertModal
);



// WEBPACK FOOTER //
// ./src/components/modals/postRequestAlert/PostRequestAlertModal.js